import type { Moment } from 'moment'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

import BodyText from 'LuxKit/Typography/BodyText'
import { INTL_SHORT_DAY_NAME_DAY_MONTH_YEAR, INTL_SHORT_TIME_FORMAT_AM_PM } from 'constants/dateFormats'
import { intlDateFormatter } from 'lib/datetime/dateUtils'

const DateTime = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: flex-start;
`

const Date = styled.div`
  flex: 1;
`
const Time = styled.div`
  flex: 1;
`

type Props = {
  date?: Moment
  time?: Moment
  day?: number
}

function SummaryDateTime({ date, time, day }: Props) {
  const intl = useIntl()

  if (!date && !time && !day) return null

  const dayLabel = intl.formatMessage(
    {
      id: 'KgtXN8GY1uRKZFP7ok17',
      defaultMessage: 'Day {day}',
      description: 'Day number label in trip itinerary summary in the trip planner',
    },
    { day },
  )

  return (
    <DateTime>
      {day && (
        <Date>
          <BodyText weight="bold" variant="medium">
            {intl.formatMessage({
              id: 'el9QYjSit5Ryee1zMAFX',
              defaultMessage: 'Day',
              description: 'Section heading for day number in trip itinerary in the trip planner item editor modal',
            })}
          </BodyText>
          <BodyText variant="large">{dayLabel}</BodyText>
        </Date>
      )}
      {!day && date && (
        <Date>
          <BodyText weight="bold" variant="medium">
            {intl.formatMessage({
              id: '4Op1aaAvBRp5RUUxz1_x',
              defaultMessage: 'Date',
              description: 'Section heading for date in trip itinerary in the trip planner',
            })}
          </BodyText>
          <BodyText variant="large">
            {intlDateFormatter(date, INTL_SHORT_DAY_NAME_DAY_MONTH_YEAR, intl.locale)}
          </BodyText>
        </Date>
      )}
      {time && (
        <Time>
          <BodyText weight="bold" variant="medium">
            {intl.formatMessage({
              id: 'TA9T47FGm-d5HU-3X-Ch',
              defaultMessage: 'Time',
              description: 'Section heading for time in trip itinerary in the trip planner',
            })}
          </BodyText>
          <BodyText variant="large">{intlDateFormatter(time, INTL_SHORT_TIME_FORMAT_AM_PM, intl.locale)}</BodyText>
        </Time>
      )}
    </DateTime>
  )
}

export default SummaryDateTime
